// EDUCATION URLS
import exp from "constants";

export const GET_DEGREES = "/api/edu/v1/course/";
export const GET_SPECIALIZATION = "/api/edu/v1/specialization";
export const GET_COLLEGE =
    "/apna-organisations/api/v1/organisation-search?limit=15&is_educational=yes&keyword={keyword}";
export const ADD_EDUCATION = "/user-profile/api/v1/profile/me/education";
export const EDIT_EDUCATION = "/user-profile/api/v1/profile/me/education/{educationId}";

// AboutMe URLS
export const API_ENRICHED_PROFILE = "user-profile/api/v1/profile/me/enriched";
export const GET_NEAREST_LOCATION = "/apna-geolocation/v2/nearest-area/";
export const GET_CITY_LIVE_NON_LIVE_SUGGESTIONS =
    "suggester/api/v3/suggestions?types=City&size=100&input=";
export const GET_AREA_SUGGESTIONS = `suggester/api/v3/suggestions?input=%SEARCH_INPUT%&types=Area&size=100&filters={"city_id":%CITY_ID%}`;
export const UPDATE_COMMUNICATION_OPTIONS = "/api/userprofile/v1/communication-options/";

// NB Loacation apis:
export const GET_NB_CITY_LIVE_NON_LIVE_SUGGESTIONS =
    "/location-service/api/area-suggestions?input=%SEARCH_INPUT%&types=%TYPE%&size=100";
export const GET_NB_AREA_SUGGESTIONS =
    "/location-service/api/area-suggestions?input=%SEARCH_INPUT%&types=%TYPE%&size=100&city_id=%CITY_ID%";
export const GET_NB_CITY_AREA_SUGGESTIONS = "/location-service/api/area-suggestions";
export const GET_NEAREST_LOCATION_V1 = "/location-service/api/area-by-coordinates/";
export const API_AGGREGATE_LOCATION = "/user-profile/api/v1/aggregate/locations";

// experience
export const GET_TITLE =
    "/suggester/api/v4/suggestions?input={keyword}&types=JobTitle&size=5";
export const GET_ALL_DEPARTMENTS = "/api/employer/v1/department";
export const GET_DEPARTMENTS =
    "/api/employer/get_suggested_candidate_department?input={keyword}";
// job_title_id query param can be passed to filter by job title
export const GET_NORMALISED_TITLE =
    "suggester/api/v1/normalizer/JobTitle/{searchKeyword}?size=1&prefix_length=2";
export const GET_NORMALISED_TITLE_V2 = "/api/userprofile/v1/job/suggestions";
export const GET_DEPARTMENTS_BY_TITLE = "/api/employer/v1/job-title-department";
export const GET_INDUSTRY_BY_COMPANY = "/apna-organisations/api/v1/organisation/{orgId}";
export const GET_INDUSTRIES = "/apna-organisations/api/v1/industries";
export const GET_INDUSTRIES_WITH_SECTOR = "/apna-organisations/api/v1/sector-industries/";
export const GET_COMPANIES =
    "/apna-organisations/api/v2/organisation-search?keyword={keyword}&limit=5";
export const ADD_EXPERIENCE = "/user-profile/api/v1/profile/me/experience";
export const EDIT_EXPERIENCE =
    "/user-profile/api/v1/profile/me/experience/{experience_id}";

// Profile
export const GET_PROFILE = "/user-profile/api/v1/profile/me/enriched?source=onboarding";
export const EDIT_PROFILE = "user-profile/api/v1/profile/me/enriched";

//Profile Image
export const GET_SIGNED_IMAGE_URLS = "/user-profile/api/v1/profile/me/doc/profile-photo";

// PReferences URLS
export const WORK_TYPE_PREFERENCES = "/user-profile/api/v1/prefs/me/job-prefs";
export const GET_LANGUAGES = "user-profile/api/v1/profile/language-fluency-list";
export const UPDATE_LANGUAGE_PREFERENCE =
    "user-profile/api/v1/profile/me/bulk/language-fluency/";
export const GET_JOB_CATEGORIES = "/job-attrib/category/search";
export const UPDATE_JOB_CATEGORIES = "/api/userprofile/v1/interests/";
export const ONBOARDING_ASSESSMENTS = "api/assessments/v1/onboarding/assessments/";
export const GET_JOB_CITIES = "/api/location/v1/cities/";
export const getSuggestedCities = (cityId: number) =>
    `api/location/v1/cities/${cityId}/suggested-cities`;
export const GET_SELECTED_JOB_CATEGORIES = "/api/userprofile/v2/user/?lang=en";
export const GET_ASSESSMENT_DETAILS =
    "/api/assessments/v1/onboarding/assessments/?categories=%category%";
export const EDIT_PREFERRED_ROLE = "/user-profile/api/v2/prefs/me/job-types/enriched";

// Skills
export const GET_TOP_RECOMMENDED_EXP_SKILLS = "/apna-skillgraph/skill/recommendation";
export const GET_TOP_RECOMMENDED_SKILLS =
    "/user-profile/api/v1/profile/me/skills/recommended/";
export const GET_SKILLS_SUGGESTIONS = (searchText: string) =>
    `/suggester/api/v2/suggestions?input=${encodeURIComponent(
        searchText
    )}&size=5&types=ProfileSkill`;
export const UPDATE_SKILLS_TO_PROFILE = "/user-profile/api/v1/profile/me/skills-bulk";

// Generics
export const GET_OR_UPDATE_DATA_COLLECTION_PROGRESS =
    "api/userprofile/v1/user/data-collection-progress/";
export const NOTIFY_ONBOARDING_COMPLETED =
    "api/userprofile/v1/user/onboarding-completed/";

//Resume
export const UPLOAD_RESUME = "/user-profile/api/v1/profile/me/doc/resume";
export const PARSE_RESUME = "/user-profile/api/v1/profile/me/enriched/parsed-resume";

export const GET_USER_PREFERENCES = "/user-profile/api/v1/prefs?defaults=false";

/* Recruiter actions */
// supports query param 'fetch_type' with values all, insights, tips, report, missing_entities, more_insights
export const HR_REPORT_CARD = "user-profile/api/v1/profile/me/performance-insights";

// Takes action query param with values of view, search, shortlist and src param with values hr_views_web, hr_shortlist_web, hr_searches_web
export const HR_DATA = "user-profile/api/v1/profile/me/employers";
export const HR_KEYWORDS = "user-profile/api/v1/profile/me/search-keywords";
export const VERIFY_EMAIL = "user-profile/api/v1/verify";
export const PERFORMANCE_FILTERS_OPTIONS =
    "user-profile/api/v1/profile/me/performance-filters";
export const GET_CONFIGURATION = "/api/v1/blind-hr-configuration";

// Community apis:
export const GET_COMMS_ONBOARDING_SUGGESTIONS =
    "/apna-channels/api/v1/follow/onboarding-topic-suggestions";
export const BULK_FOLLOW_COMMS = "/apna-channels/api/v1/follow/onboarding/topics/bulk";

// Tiger eye changes:
export const GET_TIGER_EYE_QUESTIONS =
    "profile-data-collection-service/assessment/api/v1/profile/enrichment";
export const POST_TIGER_EYE_QUESTIONS_ANSWER = "user-profile/api/v1/profile/assessment";
